var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 88,
    viewBox: "0 0 148 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1576_46984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2814 27.3124V21.7065V16.1657H43.7965V11.1465H49.3765V16.1657V21.7065H43.7965V27.3124V32.8532H38.2814V38.3939V43.9998V49.5406H43.7965V55.1465H49.3765V60.6872H54.8916H60.4067V66.228H54.8916H49.3765H43.7965H38.2814V60.6872H32.7013V55.1465V49.5406V43.9998V38.3939V32.8532V27.3124H38.2814Z",
    fill: "#8B3BE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.502 76.853H76.4981H82.0781H87.5932H93.1083V71.2471H98.6883H104.203H109.783V76.853H104.203H98.6883V82.3937H93.1083V87.9997H87.5932H82.0781H76.4981H71.502H65.9869H60.4069V82.3937V76.853H65.9869H71.502Z",
    fill: "#8B3BE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2815 38.394H43.7966V43.9348H38.2815V38.394Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3767 49.5405H54.8918V55.0813H49.3767V49.5405Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3767 11.1465H54.8918V16.1657H49.3767V11.1465Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8917 32.853H60.4068H65.9868V38.3938H60.4068V43.9997H54.8917H49.3766V38.3938H54.8917V32.853Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9868 16.1655V21.7063H60.4068V27.3122H54.8917V21.7063V16.1655H60.4068H65.9868Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4717 5.54053H65.9868V11.0813H60.4717V5.54053Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9869 44H71.502H76.498V49.5407H71.502V55.1467H65.9869H60.4069V49.5407H65.9869V44Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.498 32.8532H82.078V27.3125H87.5931H93.1082H98.6882V32.8532H93.1082H87.5931V38.394H82.078H76.498V32.8532Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4981 11.1465H71.5021V5.54053H76.4981H82.0781H87.5933V11.1465H82.0781H76.4981Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1084 49.5405V55.1465H87.5933V60.6872H82.0781V55.1465V49.5405H87.5933H93.1084Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6882 21.7065H93.1082H87.5931V16.1657H93.1082V11.1465H98.6882H104.203V16.1657H98.6882V21.7065Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6882 44H104.203V49.5407H98.6882V44Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.268 38.394H109.783V43.9348H104.268V38.394Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.783 27.3125H115.299V32.8532H109.783V27.3125Z",
    fill: "#945ECC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2814 38.3941V32.8533H43.7966V27.3126V21.7719H49.3766V16.2311H54.8917V21.7719V27.3126H60.4068V21.7719H65.922V16.2311H60.4068H54.8917V11.2119H49.3766V5.54074H54.8917V0H60.4068H65.922H71.4371H76.4331H81.9482H87.4634H92.9785V5.54074H98.6883H104.203V11.0815H98.6883H93.1732V16.1007H87.658V21.6415H93.1732H98.6883V16.1007H104.203H109.719V21.6415H115.234V27.1822H109.719V32.723H115.234H120.749V38.2637V43.8044V49.5407H115.234H109.719V55.0815H104.203H98.6883H93.1732V49.5407H87.658H82.1429V55.0815V60.6222H76.6278H71.6317V66.163H66.1166H60.6015V60.6222H55.0863H49.5712V55.0815H55.0863V49.5407H49.5712V55.0815H44.0561V49.5407H38.541V44H44.0561V38.4593H38.2814V38.3941ZM60.4068 5.54074V11.0815H65.922V5.54074H60.4068ZM87.5931 5.54074H82.078H76.5629H71.5668V11.0815H76.5629H82.078H87.5931V5.54074ZM93.1083 27.3126H87.5931H82.078V32.8533H76.5629V38.3941H82.078H87.5931V32.8533H93.1083H98.6883V27.3126H93.1083ZM104.203 49.5407V44H109.719V38.4593H104.203V44H98.6883V49.5407H104.203ZM60.4068 55.1467H65.922H71.4371V49.5407H76.4331V44H71.4371H65.922V49.5407H60.4068V55.1467ZM49.3766 44H54.8917H60.4068V38.4593H65.922V32.9185H60.4068H54.8917V38.4593H49.3766V44Z",
    fill: "#AC73DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.593 55.1465H93.1082V60.6872H87.593V55.1465Z",
    fill: "#AC73DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6753 55.1465V60.6872V66.228H11.0953V60.6872V55.1465H16.6753Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6104 49.5405H21.6064V55.0813H16.6104V49.5405Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1863 66.228H32.7014H38.2814H43.7966H49.3766H54.8917H60.4068H65.9868H71.502V71.2473H65.9868H60.4068H54.8917H49.3766H43.7966H38.2814H32.7014H27.1863H21.6063H16.6751V66.228H21.6063H27.1863Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1863 44H32.7014V49.5407H27.1863H21.6063V44H27.1863Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4979 60.6875H82.0779H87.593H93.1082V66.2282H87.593H82.0779H76.4979H71.5018V60.6875H76.4979Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6883 55.1465H104.203H109.783V60.6872H104.203H98.6883H93.1083V55.1465H98.6883Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.298 49.5405H120.813V55.1465H115.298H109.783V49.5405H115.298Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.394 44H131.39V49.5407H126.394H120.814V44H126.394Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.814 32.8532H115.298V27.3125H120.814H126.394H131.39V32.8532H126.394H120.814Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39 32.853H136.905V38.3938V43.9997H131.39V38.3938V32.853Z",
    fill: "#9E005D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0951 55.1465V60.6872V66.228H16.6751V71.2472H21.6063H27.1863H32.7014H38.2814H43.7966H49.3766H54.8917H60.4068H65.9868H71.502V76.8532H65.9868H60.4068H54.8917H49.3766H43.7966H38.2814H32.7014H27.1863H21.6063H16.6751H11.0951V71.2472H5.57999V66.228V60.6872V55.1465H11.0951Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1602 49.5405H16.6753V55.0813H11.1602V49.5405Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6104 44H21.6064V49.5407H16.6104V44Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1863 38.394H32.7014V44H27.1863H21.6063V38.394H27.1863Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4981 66.228H82.0781H87.5933H93.1084V71.2473H87.5933H82.0781H76.4981H71.5021V66.228H76.4981Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6883 60.6875H104.203H109.783V66.2282H104.203H98.6883H93.1083V60.6875H98.6883Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.299 55.1465H120.814V60.6872H115.299H109.783V55.1465H115.299Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.394 49.5405H131.39V55.1465H126.394H120.814V49.5405H126.394Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.814 27.3125H115.298V21.7065H120.814H126.394H131.39V27.3125H126.394H120.814Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.905 43.9997V38.3938V32.853H142.485V38.3938V43.9997V49.5404H136.905H131.39V43.9997H136.905Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.39 27.3125H136.905V32.8532H131.39V27.3125Z",
    fill: "#E84D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58008 55.147V60.6877V66.2285V71.2477H6.53267e-05V66.2285V60.6877V55.147H5.58008Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58009 71.2476H11.0952V76.7883H5.58009V71.2476Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58009 49.541H11.0952V55.0818H5.58009V49.541Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1602 44H16.6753V49.5407H11.1602V44Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6104 38.394H21.6064V43.9348H16.6104V38.394Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1862 76.8535H32.7013H38.2814H43.7965H49.3765H54.8916H60.4067V82.3943H54.8916H49.3765H43.7965H38.2814H32.7013H27.1862H21.6062H16.675V76.8535H21.6062H27.1862Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1863 32.8535H32.7014V38.3943H27.1863H21.6063V32.8535H27.1863Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0781 71.2476H87.5933H93.1084V76.8535H87.5933H82.0781H76.4981H71.5021V71.2476H76.4981H82.0781Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6883 66.228H104.203H109.783V71.2473H104.203H98.6883H93.1083V66.228H98.6883Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.299 60.6875H120.814V66.2282H115.299H109.783V60.6875H115.299Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.394 55.147H131.39V60.6877H126.394H120.814V55.147H126.394Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.814 21.7068H115.298H109.783V16.166H115.298H120.814H126.394H131.39V21.7068H126.394H120.814Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.905 49.541H142.485V55.1469H136.905H131.39V49.541H136.905Z",
    fill: "#FF7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.485 38.394V32.8532H136.905V27.3125H131.39V21.7065H136.905H142.485V27.3125H148V32.8532V38.394V43.9999V49.5406H142.485V43.9999V38.394Z",
    fill: "#FF7BAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1576_46984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 88,
    fill: "white",
    transform: "matrix(-1 0 0 1 148 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.e170a4d2fe61b2b9cecd8b97540b4619.svg";
export { ForwardRef as ReactComponent };